"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _container = require("./container.proptypes");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var extractMargin = function extractMargin(_ref) {
  var margin = _ref.margin,
    theme = _ref.theme;
  return margin ? "".concat(theme.space[margin[0]], " ").concat(theme.space[margin[1]], " ").concat(theme.space[margin[2]], "  ").concat(theme.space[margin[3]], " ") : "0px";
};
var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Container__ContainerWrapper",
  componentId: "sc-o4w52s-0"
})(["height:", ";outline:none !important;border-radius:", ";margin:", ";scroll-snap-align:start;&:focus-within{border:", ";}box-sizing:border-box;", ";"], function (_ref2) {
  var height = _ref2.height;
  return height ? 'auto' : "fit-content";
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.normal;
}, function (props) {
  return extractMargin(props);
}, function (_ref4) {
  var theme = _ref4.theme,
    focusEffect = _ref4.focusEffect;
  return focusEffect && "1px solid  ".concat(theme.colors.secondaryDark);
}, function (_ref5) {
  var width = _ref5.width;
  return width && "width: ".concat(width, "\n   ");
});
var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "Container__HeaderWrapper",
  componentId: "sc-o4w52s-1"
})(["border-bottom:1px solid ", ";padding:", " ", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyLight;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.standard;
});
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "Container__StyledContainer",
  componentId: "sc-o4w52s-2"
})(["", " ", " border-radius:", ";box-sizing:border-box;", ";background-color:", ";", ""], function (_ref9) {
  var hasBoxShadow = _ref9.hasBoxShadow,
    theme = _ref9.theme;
  return hasBoxShadow && "\n      box-shadow: 0px 1px ".concat(theme.space.micro, " rgba(0, 0, 0, 0.16);\n  ");
}, function (_ref10) {
  var hasBorder = _ref10.hasBorder,
    borderColor = _ref10.borderColor,
    theme = _ref10.theme;
  return hasBorder && "\n      border: 1px solid ".concat(borderColor ? theme.colors[borderColor] : theme.colors.secondary, ";\n  ");
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.micro;
}, function (props) {
  return props.height ? "height: ".concat(props.height) : "min-height: ".concat(props.theme.space.XXLarge);
}, function (_ref12) {
  var theme = _ref12.theme,
    color = _ref12.color;
  return color ? theme.colors[color] : theme.colors.default;
}, function (_ref13) {
  var hoverEffect = _ref13.hoverEffect,
    hasBoxShadow = _ref13.hasBoxShadow;
  return hoverEffect && hasBoxShadow && "&:hover {\n       box-shadow:  0px 4px 8px rgba(0, 0, 0, 0.12);\n   ";
});
exports.StyledContainer = StyledContainer;
var ChildWrapper = _styledComponents.default.div.withConfig({
  displayName: "Container__ChildWrapper",
  componentId: "sc-o4w52s-3"
})(function (_ref14) {
  var theme = _ref14.theme,
    isSideBySide = _ref14.isSideBySide,
    layout = _ref14.layout,
    alignChildren = _ref14.alignChildren,
    gap = _ref14.gap,
    height = _ref14.height;
  return "\n    ".concat(isSideBySide ? "\n          display: grid;\n          grid-template-columns: repeat(".concat(layout, ",\n            calc((100%/").concat(layout, ") - ((").concat(theme.space[gap], "/").concat(layout, ") * (").concat(layout, " - 1))));\n          align-items: ").concat(alignChildren, ";\n          grid-gap: ").concat(theme.space[gap], ";\n        ") : "height: ".concat(height, ";"), "\n  ");
});
var Container = function Container(props) {
  var theme = props.theme,
    focusEffect = props.focusEffect,
    width = props.width,
    margin = props.margin,
    customProperties = props.customProperties,
    accessible = props.accessible,
    hoverEffect = props.hoverEffect,
    height = props.height,
    color = props.color,
    children = props.children,
    columnSpan = props.columnSpan,
    header = props.header,
    isSideBySide = props.isSideBySide,
    layout = props.layout,
    alignChildren = props.alignChildren,
    gapChildren = props.gapChildren,
    hasBoxShadow = props.hasBoxShadow,
    hasBorder = props.hasBorder,
    borderColor = props.borderColor;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var finalLayout = layout > 1 ? layout : 2;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ContainerWrapper, (0, _extends2.default)({
      tabIndex: tabIndex,
      focusEffect: focusEffect,
      width: width,
      margin: margin,
      columnSpan: columnSpan,
      theme: themeContext
    }, customProperties, {
      height: height
    }), /*#__PURE__*/_react.default.createElement(StyledContainer, {
      hoverEffect: hoverEffect,
      height: height,
      color: color,
      hasBoxShadow: hasBoxShadow,
      hasBorder: hasBorder,
      borderColor: borderColor
    }, header ? /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: true,
      display: "inlineFlex",
      hasToggle: false,
      theme: "AIRASIA_CLASSIC",
      type: "default"
    }, header)) : null, /*#__PURE__*/_react.default.createElement(ChildWrapper, {
      isSideBySide: isSideBySide,
      layout: finalLayout,
      alignChildren: alignChildren,
      gap: gapChildren,
      height: height
    }, children)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Container.propTypes = _container.ContainerProptypes.PropTypes;
Container.defaultProps = _container.ContainerProptypes.DefaultProps;
var _default = Container;
exports.default = _default;